import { Service } from "@/interfaces/service";
import axios from "@/lib/axios";
import { useServicesStore } from "@/stores/services";
import { useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";
import { watch } from "vue";

const getServices = async () => {
  // new Promise((resolve) => setTimeout(resolve, 1000));
  const { data } = await axios.get<Service[]>(`/api/services`);
  return data;
};

const useServices = () => {
  const { data, isError, isLoading, refetch, isSuccess } = useQuery(
    ["services"],
    getServices,
  );
  const { setServices, getService } = useServicesStore();
  const { services } = storeToRefs(useServicesStore());

  watch(
    data,
    (value) => {
      if (value) {
        setServices(value);
      }
    },
    {
      immediate: true,
    },
  );

  return {
    services,
    isError,
    isLoading,
    isSuccess,

    refetch: () => {
      setServices([]);
      return refetch();
    },
    getService,
  };
};

export default useServices;
